/* tslint:disable */
/* eslint-disable */
export enum WorkUseremploymentMutationTypesEnum {
  Eintritt = 'EINTRITT',
  Austritt = 'AUSTRITT',
  Aenderung = 'AENDERUNG'
}
